<template>
    <div id="leaderboard">
        <button id="leaderboardButton" class="ui button primary" @click="leaderboardClick">Leaderboard</button>
        <modal modalTransition="fade" v-model="showModal" class="leaderboards">
            <p slot="header">Leaderboard <button class="ui icon button" id="closeLeaderboard" @click="showModal=false"><i class="icon times" ></i>
                </button>
                
            </p>

            <div slot="content" class="ui list">
                <div class="ui description"><i>Leaderboard is updated every 60 minutes.</i></div>
                <div class="ui grid container middle aligned">
                    <div class="ui row" v-for="leader in leaderboardData" :key="leader.rank" v-bind:class="{ item: true, current: leader.current == true }">
                            <div class="two wide column">
                                <div v-bind:class="{circle: true, current: leader.current == true }">{{ leader.rank }}</div>
                            </div>
                            <div class="eight wide column left floated">
                                <div class="left" >{{ leader.name }}</div>
                            </div>
                            <div class="four wide column right floated">
                                <div class="right">{{ leader.points }}</div>
                            </div>
                    </div>
                </div>
            </div>

            <template slot="actions">
                <div class="ui primary right button" @click="confirm">
                Close
                </div>
            </template>

        </modal>
    </div>
</template>
<script>
import modal from 'vue-semantic-modal'
import $ from 'jquery'
export default {
   
    components: {
        modal
    },
    props: ['leaderboardData'],
    data() {
        return {
            showing: false,
            showModal: false,
            confirmed: false
        }
    },
    methods: {
        leaderboardClick: function() {
            this.showModal = true
            this.confirmed = false
        },
        hideLeaderboard: function() {
            this.showing = false;
        },
        mainClick: function(event) {
            event.preventDefault();
            event.stopPropagation();
        },
        confirm: function() {
            this.confirmed = true
            this.showModal = false
        }
    },
    mounted() {
        const isMobile = /Mobi/.test(window.navigator.userAgent)
        if (!isMobile) {
            if (window.devicePixelRatio !== 1)
            {
                    let scaleValue = (1/window.devicePixelRatio);
                    $('.ui.modal').css('transform','translateX(-25%) scale('+scaleValue+')');
            }
        }
    }
}
</script>
<style>
#leaderboard  {
    text-align: center;
    margin-top: 5px;
}
#leaderboard .ui.modal {
    margin: auto!important;
    position: relative!important;
    width: 480px;
    
  }

#closeLeaderboard {
    position: absolute;
    right: 15px;
}
.ui.modal .header {
    background-color: #eee;
    color: #444;
}

.ui.modal {
    transform-origin: center;
}

</style>
<style scoped>
.current {
    font-weight: bold;
}
.column .circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    background-color:#1B364F;
    color: #fff;
    text-align: center;
    padding-top: 4px;
}
.circle.current {
    background-color:#67B44B;
}
.modal .description {
    margin-bottom: 15px;
    text-align: center;
}
.row {
    padding: 7px !important;
    text-align: center;
}
.grid {
    width: 360px !important;
    margin: 0 auto !important;
}
.column .left {
    text-align: left;
}
.column .right {
    text-align: right;
}
.three.wide.column {
    position: relative;
    text-align: right;
}
.column {
    font-size: 16px;
}
.six.wide.column {
    padding-top: 6px;
}

</style>
<style>
@media (max-width: 640px) {
    .dimmer {
        padding: 0 !important;
    }
    .modal {
        width: 100% !important;
        height: 100% !important;
        border-radius: 0 !important;
    }
    .modal .actions {
        position: absolute !important;
        bottom: 0px !important;
        width: 100% !important;
    }
    .modal .content {
        font-size: 12px !important;
    }
    .column {
        font-size: 14px !important;
        padding-top: 5px;
    }
    .column .circle {
        padding-top: 5px !important;
        width: 26px !important;
        height: 26px !important;
    }
    .row.item {
        height: 35px;
    }
    .eight .left {
        padding-left: 10px;
    }
}


</style>
